import { ApolloLink } from '@apollo/client';
import { allowedAtlassianFields } from '../allowedAtlassianFields';

// eslint-disable-next-line @trello/no-module-logic
export const blockQueryingTrelloAndAtlassianLink = new ApolloLink(
  (operation, forward) => {
    // We skip this expensive check in production on the assumption that any problems with querying from both endpoints
    // are resolved in the development environment.
    if (process.env.NODE_ENV === 'production') {
      return forward(operation);
    }

    let hasAtlassianSelection = false;
    let hasTrelloSelection = false;

    operation.query.definitions.forEach((definition) => {
      if (definition.kind === 'OperationDefinition') {
        definition.selectionSet.selections.forEach((selection) => {
          if (selection.kind === 'Field') {
            if (allowedAtlassianFields.Query.includes(selection.name.value)) {
              hasAtlassianSelection = true;
            } else {
              hasTrelloSelection = true;
            }
          }
        });
      }
    });

    if (
      hasAtlassianSelection &&
      hasTrelloSelection &&
      process.env.NODE_ENV !== 'production'
    ) {
      throw new Error(
        'Querying data from Atlassian GraphQL Gateway and Trello GraphQL in the same query is not currently supported. Please split the query.',
      );
    }

    return forward(operation);
  },
);
